module.exports = __webpack_public_path__ + "static/media/package-init.8ff95940.png";